import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: ${({ align }) => align};

  margin-bottom: 30px;
`;
